exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.break-protect {\n    -moz-column-break-inside: auto;\n         break-inside: auto;\n}\n.body {\n    margin: 25mm;\n}\n@page {\n    margin-top: 1in;\n    margin-bottom: 1in;\n}\n", ""]);

// exports
